import React from 'react';
import InternalContainer from '../../layout/containers/Internal';
import { InternalTabs } from '../../layout/components';
import SchemeChannelsList from '../components/InsurerSchemeChannelsList/InsurerSchemeChannelsList';

const InsurerSchemesChannelContainer = ({ params: { insurerCode } }) => {
  return (
    <InternalContainer title={'Channels'}>
      <InternalTabs
        id={'channel-scheme-tabs'}
        tabs={[
          {
            permissions: ['scheme.edit'],
            title: 'Test Schemes',
            content: (
              <SchemeChannelsList schemeStatus={'test'} insurerCode={insurerCode} />
            ),
          },
          {
            permissions: ['scheme.edit'],
            title: 'Pending Schemes',
            content: (
              <SchemeChannelsList schemeStatus={'pending'} insurerCode={insurerCode} />
            ),
          },
          {
            permissions: ['scheme.edit'],
            title: 'Active Schemes',
            content: (
              <SchemeChannelsList schemeStatus={'active'} insurerCode={insurerCode} />
            ),
          },
          {
            permissions: ['scheme.edit'],
            title: 'Ended Schemes',
            content: (
              <SchemeChannelsList schemeStatus={'ended'} insurerCode={insurerCode} />
            ),
          },
        ]}
      />
    </InternalContainer>
  );
};

export default InsurerSchemesChannelContainer;
